import React from 'react'
import { withStyles, createStyles } from '@mui/styles'
import { Grid } from '@mui/material'
import { hasFeature } from '../../../infrastructure/feature'
import { t } from '../../../infrastructure/i18nextHelper'
import { Switch } from '../../common/customComponents'
import { muiOptions } from '../../../infrastructure/materialUiThemeProvider'
import { StockFiltersContainer } from './filtersStore'

function _StockPercentUsefulStockFilters() {
    let stockFiltersStore = StockFiltersContainer.useContainer()
    let toggleStockPercentHigh = () => stockFiltersStore.filters.setStockPercentHigh(!stockFiltersStore.filters.stockPercentHigh)
    let toggleUsefulStock = () => stockFiltersStore.filters.setUsefulStock(!stockFiltersStore.filters.usefulStock)

    return (
        <div className={'stockFilters'}>
            <Grid container spacing={0} justifyContent='space-between' alignItems='flex-end' direction='row'>
                <UsefulStock isChecked={stockFiltersStore.filters.usefulStock} toggleHandler={toggleUsefulStock} disabled={stockFiltersStore.filters.disablePhysicalStockUsage}/>
                {hasFeature('StockPercentUsage') &&
                    <Grid item>
                        <Switch changeCallback={toggleStockPercentHigh} isChecked={stockFiltersStore.filters.stockPercentHigh}
                            title={t('stock.filters.stockPercentHighTooltip')}
                            onText={t('stock.filters.stockPercentHighOn')} offText={t('stock.filters.stockPercentHighOff')} />
                    </Grid>}
            </Grid>
        </div>
    )
}

export let UsefulStock = ({ isChecked, toggleHandler, disabled }: { isChecked: boolean, toggleHandler: () => void, disabled?: boolean}):
    JSX.Element | null => {
    return (
        <Grid item>
            <Switch changeCallback={toggleHandler} isChecked={isChecked}
                disabled={disabled}
                title={t('stock.filters.usefulStockTooltip')}
                onText={t('stock.filters.usefulStockOn')} offText={t('stock.filters.usefulStockOff')} />
        </Grid>
    )
}

let styles = _ => createStyles({})

export let StockPercentUsefulStockFilters = withStyles(styles, muiOptions)(_StockPercentUsefulStockFilters)